import React from 'react';
import useScrollToTop from './useScrollToTop';

const ScrollToTop = () => {
    useScrollToTop();
    return null;
};

export default ScrollToTop;
